import { render, staticRenderFns } from "./Postcodecheckerhh.vue?vue&type=template&id=521fc908&scoped=true"
import script from "./Postcodecheckerhh.vue?vue&type=script&lang=js"
export * from "./Postcodecheckerhh.vue?vue&type=script&lang=js"
import style0 from "./Postcodecheckerhh.vue?vue&type=style&index=0&id=521fc908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521fc908",
  null
  
)

export default component.exports